import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'contrib-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss', '../welcome/welcome.component.scss']
})
export class NotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
